import { fromJS } from 'immutable';

import {ApiUrl2, ClientId, UserToken, PrevilageId} from '../../../helper/HelperAuth'
import { GetGroupTemplate } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, body, isadmin) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrl2 + 'config-templategroup-list';

    if(page === undefined){
        page = 1;
    }

    let clientId = 0

    if (PrevilageId != 1 && isadmin == false) clientId = ClientId
    if (body === '' || body === null || body === undefined) {
        body = {
            'client-id' : clientId,
            'group-name' : ''
        }
    }

    var query = {
        "search":body,
        "page":page,
        "page-size":2000,
        "order-by":1,
        "order":"ASC",
    };

    var paramBody = {
        "query": query
    };

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('queryResult');
        data = data.get('data');
    }

    dispatch({ type: GetGroupTemplate, data: fromJS(data) });
};